module.exports = __webpack_public_path__ + "img/get-google-play.5460f0d5.png";